import { useState } from "react";
import DtoolsOptionComponentGroupsSection from "@/components/sales/dtools/DtoolsOptionComponentGroupsSection";
import { DtoolsReviewPrimaryBlock } from "@/components/sales/dtools/DtoolsReviewLineCard";
import { Button } from "@/components/ui/button";
import { PROPOSAL_COPY_FONT, PROPOSAL_TEXT } from "@/lib/proposalTheme";
import { buildDtoolsOptionRoomGroups } from "@shared/dtoolsCustomerProposalView";
import type { DtoolsViewSortMode } from "@shared/dtoolsCustomerProposalView";
import type { DtoolsReviewSystem } from "@shared/dtoolsStagingTransform";
import { useDtoolsPdfPackageMode } from "@/components/sales/dtools/DtoolsPdfPackageContext";

type Props = {
  system: DtoolsReviewSystem;
};

export default function DtoolsOptionEquipmentView({ system }: Props) {
  const pdfPackageMode = useDtoolsPdfPackageMode();
  const [sortMode, setSortMode] = useState<DtoolsViewSortMode>("option");
  const roomGroups = buildDtoolsOptionRoomGroups(system);

  return (
    <div className="space-y-4" data-testid="dtools-option-equipment-view" style={{ fontFamily: PROPOSAL_COPY_FONT }}>
      {!pdfPackageMode ? (
        <div className="flex flex-wrap gap-2" data-testid="dtools-option-equipment-sort">
          <Button
            type="button"
            size="sm"
            variant={sortMode === "option" ? "default" : "outline"}
            onClick={() => setSortMode("option")}
          >
            Sort by Option
          </Button>
          <Button
            type="button"
            size="sm"
            variant={sortMode === "rooms" ? "default" : "outline"}
            onClick={() => setSortMode("rooms")}
          >
            Sort by Room
          </Button>
        </div>
      ) : null}

      {sortMode === "option" ? (
        <DtoolsOptionComponentGroupsSection system={system} />
      ) : (
        <div className="space-y-6">
          {roomGroups.map((room) => (
            <section key={room.name} className="space-y-3">
              <h3 className="text-sm font-semibold uppercase tracking-[0.14em]" style={{ color: PROPOSAL_TEXT }}>
                {room.name}
              </h3>
              <div className="space-y-4">
                {room.primaries.map((block) => (
                  <DtoolsReviewPrimaryBlock key={block.line.id} block={block} />
                ))}
              </div>
            </section>
          ))}
        </div>
      )}
    </div>
  );
}
